// renderLastThreeJobs.js
import React from "react";

export function renderLastThreeJobs(candidateCompany = []) {
  if (!Array.isArray(candidateCompany)) return null;

  const lastThree = candidateCompany.slice(-3);

  return lastThree.map((job, index) => (
    <React.Fragment key={index}>
      {job.job_title}
      {index < lastThree.length - 1 && (
        <span>
          ,<br />
        </span>
      )}
    </React.Fragment>
  ));
}

export function renderLastThreeIndustry(candidateCompany = []) {
  if (!Array.isArray(candidateCompany)) return null;

  // Extract industries from the end, removing duplicates while preserving order
  const seen = new Set();
  const distinctIndustries = [];

  // Loop from end to start to preserve the most recent entries
  for (
    let i = candidateCompany.length - 1;
    i >= 0 && distinctIndustries.length < 3;
    i--
  ) {
    const industry = candidateCompany[i]?.job_industry;
    if (industry && !seen.has(industry)) {
      seen.add(industry);
      distinctIndustries.unshift(industry); // Add to front to maintain correct order
    }
  }

  return distinctIndustries.map((industry, index) => (
    <React.Fragment key={index}>
      {industry}
      {index < distinctIndustries.length - 1 && (
        <span>
          ,<br />
        </span>
      )}
    </React.Fragment>
  ));
}



export function renderLastThreeJobsAsString(candidateCompany = []) {
    if (!Array.isArray(candidateCompany)) return "N/A";
  
    const lastThree = candidateCompany.slice(-3);
    return lastThree
      .map((job) => job.job_title || "N/A")
      .join(",\n");
  }



  export function renderLastThreeIndustryAsString(candidateCompany = []) {
    if (!Array.isArray(candidateCompany)) return "N/A";
  
    const seen = new Set();
    const distinctIndustries = [];
  
    for (let i = candidateCompany.length - 1; i >= 0 && distinctIndustries.length < 3; i--) {
      const industry = candidateCompany[i]?.job_industry;
      if (industry && !seen.has(industry)) {
        seen.add(industry);
        distinctIndustries.unshift(industry); // maintain order
      }
    }
  
    return distinctIndustries.join(",\n");
  }
  
  